
import CryptoJS from 'crypto-js';
import { cacheManager } from '../../../utils/cacheManager';

const secretKey = 'pulse-reader-secret-key';
const CACHE_KEY_PREFIX = 'chapter-content-';

export const decryptContent = async (content: string | undefined): Promise<string> => {
  if (!content) return '';
  
  // Generate cache key from content
  const cacheKey = `${CACHE_KEY_PREFIX}${CryptoJS.MD5(content).toString()}`;
  
  try {
    // Try to get decrypted content from cache first
    const cachedContent = await cacheManager.get<string>(
      'chapterContent',
      cacheKey
    );
    
    if (cachedContent) {
      console.log('Using cached decrypted content');
      return cachedContent;
    }
    
    // If not in cache, decrypt and store
    let decryptedContent: string;
    
    if (content.startsWith('enc:')) {
      try {
        const encryptedContent = content.substring(4);
        const bytes = CryptoJS.AES.decrypt(encryptedContent, secretKey);
        decryptedContent = bytes.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        console.error('Error decrypting content:', error);
        return '<p>Error: Unable to decrypt content</p>';
      }
    } else {
      decryptedContent = content;
    }
    
    // Store in cache
    await cacheManager.set(
      'chapterContent',
      cacheKey,
      decryptedContent,
      24 * 60 * 60 * 1000 // 24 hours
    );
    
    return decryptedContent;
  } catch (error) {
    console.error('Cache error:', error);
    // Fallback to regular decryption if cache fails
    if (content.startsWith('enc:')) {
      try {
        const encryptedContent = content.substring(4);
        const bytes = CryptoJS.AES.decrypt(encryptedContent, secretKey);
        return bytes.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        console.error('Error decrypting content:', error);
        return '<p>Error: Unable to decrypt content</p>';
      }
    }
    return content;
  }
};
